export default {
  type: "Feature",
  properties: { 
    name: "Эрдэнэт",
    location: [48.999, 104.27547] },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [104.37801361083984, 48.899258060699516],
        [104.34677124023438, 48.90805939965008],
        [104.30694580078125, 48.927913136732556],
        [104.24514770507812, 48.94595514118904],
        [104.1558837890625, 48.957678947281124],
        [103.99932861328124, 48.98562459864604],
        [103.99932861328124, 49.03876821195109],
        [104.05838012695312, 49.095452162534826],
        [104.10232543945312, 49.12062427498834],
        [104.2822265625, 49.080162863460984],
        [104.33303833007812, 49.11882669045988],
        [104.39071655273438, 49.1314084139986],
        [104.44427490234375, 49.127813961593255],
        [104.51946258544922, 49.106017014812096],
        [104.5184326171875, 49.105342729732754],
        [104.53765869140625, 49.06936758241039],
        [104.57061767578125, 49.026162996368946],
        [104.56100463867188, 48.99463598353408],
        [104.47723388671875, 48.942347261978476],
        [104.37698364257812, 48.89993514180326],
        [104.37801361083984, 48.899258060699516],
      ],
    ],
  },
};
